export const SET_RESULTS_MONTHLY_CHART = "SET_RESULTS_MONTHLY_CHART";
export const SET_RESULTS_WEEKLY_CHART = "SET_RESULTS_WEEKLY_CHART";
export const SET_RESULTS_ANNUAL_CHART = "SET_RESULTS_ANNUAL_CHART";
export const SET_RESULTS_HAPPINESS = "SET_RESULTS_HAPPINESS";